import React from "react";
import { ScrollView, StyleSheet, Text, View } from "react-native";
import { conversationStartersData } from "../../../data/conversationStarters.data";

type ConversationPanelMobileProps = {
  onClose?: () => void;
};

export default function ConversationPanelMobile(
  _: ConversationPanelMobileProps,
) {
  return (
    <View style={styles.panel}>
      <Text style={styles.title}>Conversation Starters</Text>
      <Text style={styles.subtitle}>
        Gentle prompts to help the conversation flow when you&#39;re not sure
        where to begin.
      </Text>

      <ScrollView
        style={styles.scrollView}
        showsVerticalScrollIndicator={false}
      >
        {conversationStartersData.map((section, sectionIndex) => (
          <View key={sectionIndex} style={styles.section}>
            <Text style={styles.sectionTitle}>{section.title}</Text>
            {section.description ? (
              <Text style={styles.sectionDesc}>{section.description}</Text>
            ) : null}
            {section.questions.map((question, questionIndex) => (
              <Text key={questionIndex} style={styles.questionText}>
                {"\u2022"} {question}
              </Text>
            ))}
          </View>
        ))}
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  panel: {
    backgroundColor: "#2E2F42",
    borderRadius: 16,
    paddingVertical: 18,
    paddingHorizontal: 18,
    maxHeight: 360,
  },
  title: {
    fontSize: 18,
    fontWeight: "700",
    color: "#fff",
    fontFamily: "LexendBold",
  },
  subtitle: {
    marginTop: 6,
    fontSize: 13,
    lineHeight: 18,
    color: "#DD9832",
    fontFamily: "Lexend",
  },
  scrollView: {
    marginTop: 12,
  },
  section: {
    marginBottom: 14,
  },
  sectionTitle: {
    fontSize: 15,
    fontWeight: "700",
    color: "#DD9832",
    marginBottom: 6,
    fontFamily: "LexendBold",
  },
  sectionDesc: {
    fontSize: 12,
    color: "#DD9832",
    fontFamily: "Lexend",
    marginBottom: 8,
  },
  questionText: {
    fontSize: 13,
    color: "#fff",
    lineHeight: 18,
    fontFamily: "Lexend",
    marginBottom: 6,
  },
});
